var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "cl-wrap" }, [
    _c(
      "div",
      { staticClass: "cl-header" },
      [
        _vm._m(0),
        _vm._v(" "),
        _c("el-switch", {
          attrs: {
            value: _vm.contactum_cond.condition_status === "yes",
            "active-color": "#2563eb"
          },
          on: { change: _vm.toggleCondition }
        })
      ],
      1
    ),
    _vm._v(" "),
    _vm.contactum_cond.condition_status === "yes"
      ? _c("div", { staticClass: "cl-body" }, [
          _c(
            "div",
            { staticClass: "cl-sentence" },
            [
              _c(
                "el-select",
                {
                  staticClass: "cl-sel cl-sel--action",
                  attrs: { size: "small" },
                  model: {
                    value: _vm.contactum_cond.cond_action,
                    callback: function($$v) {
                      _vm.$set(_vm.contactum_cond, "cond_action", $$v)
                    },
                    expression: "contactum_cond.cond_action"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "Show", value: "show" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "Hide", value: "hide" } })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "cl-sentence__text" }, [
                _vm._v("this field if")
              ]),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  staticClass: "cl-sel cl-sel--logic",
                  attrs: { size: "small" },
                  model: {
                    value: _vm.contactum_cond.cond_logic,
                    callback: function($$v) {
                      _vm.$set(_vm.contactum_cond, "cond_logic", $$v)
                    },
                    expression: "contactum_cond.cond_logic"
                  }
                },
                [
                  _c("el-option", { attrs: { label: "ALL", value: "all" } }),
                  _vm._v(" "),
                  _c("el-option", { attrs: { label: "ANY", value: "any" } })
                ],
                1
              ),
              _vm._v(" "),
              _c("span", { staticClass: "cl-sentence__text" }, [
                _vm._v("of these match:")
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "cl-conditions" },
            [
              _vm._l(_vm.conditions, function(condition, index) {
                return [
                  index > 0
                    ? _c(
                        "div",
                        { key: "sep-" + index, staticClass: "cl-connector" },
                        [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.contactum_cond.cond_logic === "any"
                                  ? "OR"
                                  : "AND"
                              )
                            )
                          ])
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    { key: index, staticClass: "cl-row" },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "cl-sel cl-sel--field",
                          attrs: { size: "small", placeholder: "Select field" },
                          model: {
                            value: condition.name,
                            callback: function($$v) {
                              _vm.$set(condition, "name", $$v)
                            },
                            expression: "condition.name"
                          }
                        },
                        _vm._l(_vm.dependencies, function(dep) {
                          return _c("el-option", {
                            key: dep.name,
                            attrs: { label: dep.label, value: dep.name }
                          })
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticClass: "cl-sel cl-sel--op",
                          attrs: { size: "small" },
                          model: {
                            value: condition.operator,
                            callback: function($$v) {
                              _vm.$set(condition, "operator", $$v)
                            },
                            expression: "condition.operator"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "equals", value: "=" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "not equals", value: "!=" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "contains", value: "contains" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: {
                              label: "not contains",
                              value: "not_contains"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.get_condition_option(condition.name).length
                        ? _c(
                            "el-select",
                            {
                              staticClass: "cl-sel cl-sel--val",
                              attrs: {
                                size: "small",
                                placeholder: "Select value"
                              },
                              model: {
                                value: condition.option,
                                callback: function($$v) {
                                  _vm.$set(condition, "option", $$v)
                                },
                                expression: "condition.option"
                              }
                            },
                            _vm._l(
                              _vm.get_condition_option(condition.name),
                              function(opt) {
                                return _c("el-option", {
                                  key: opt.option_value,
                                  attrs: {
                                    label: opt.option_label,
                                    value: opt.option_label
                                  }
                                })
                              }
                            ),
                            1
                          )
                        : _c("el-input", {
                            staticClass: "cl-sel cl-sel--val",
                            attrs: { size: "small", placeholder: "Value" },
                            model: {
                              value: condition.option,
                              callback: function($$v) {
                                _vm.$set(condition, "option", $$v)
                              },
                              expression: "condition.option"
                            }
                          }),
                      _vm._v(" "),
                      _vm.conditions.length > 1
                        ? _c(
                            "button",
                            {
                              staticClass: "cl-row__del",
                              attrs: { title: "Remove" },
                              on: {
                                click: function($event) {
                                  return _vm.delete_condition(index)
                                }
                              }
                            },
                            [_c("i", { staticClass: "el-icon-close" })]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ]
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "button",
            { staticClass: "cl-add-btn", on: { click: _vm.add_condition } },
            [
              _c("i", { staticClass: "el-icon-plus" }),
              _vm._v(" Add condition\n    ")
            ]
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "cl-header__info" }, [
      _c("span", { staticClass: "cl-header__label" }, [
        _vm._v("Conditional Logic")
      ]),
      _vm._v(" "),
      _c("span", { staticClass: "cl-header__desc" }, [
        _vm._v("Show or hide this field based on other field values")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }